<div class="ms-shell" [class.ms-resizing]="!!resizing">

  <!-- Left pane: source training -->
  <aside class="ms-source" [style.width.%]="leftWidth">

    <div class="ms-source-head">
      <span>Source Content</span>
      @if (sourceId) {
        <span class="ms-preview-link" (click)="openInEditor(sourceId)">Open in Editor</span>
      }
    </div>

    <div class="ms-search">
      <input type="text"
        [(ngModel)]="sourceSearch"
        (ngModelChange)="onSourceSearch($event)"
        (focus)="showSourceDropdown = true"
        placeholder="Load content...">
      @if (showSourceDropdown && sourceResults.length > 0) {
        <div class="ms-dropdown">
          @for (item of sourceResults; track item.id) {
            <div class="ms-dropdown-item" (mousedown)="selectSource(item)">
              {{ item.name?.replaceAll('"', '') }}
            </div>
          }
        </div>
      }
    </div>

    @if (sourceMetadata) {
      <div class="ms-source-meta">
        <div class="ms-source-name">{{ sourceMetadata.name }}</div>
        <div class="ms-source-type">{{ sourceMetadata.type }}</div>
      </div>
    }

    @if (sourceLoading) {
      <div class="ms-hint">Loading...</div>
    }

    <div class="ms-tree">
      <app-tree
        [items]="sourceItems"
        [level]="0"
        [treeType]="'source'"
        [isEditingEnabled]="false"
        [isReorderEnabled]="false"
        [isDualPane]="false"
        [selectedItemId]="selectedRouteId"
        [showSelectButton]="true"
        (itemClicked)="onTreeItemClicked($event)">
      </app-tree>
    </div>

  </aside>

  <div class="ms-handle" (mousedown)="startResize('left', $event)"></div>

  <!-- Center pane: target trainings -->
  <main class="ms-targets">

    <div class="ms-targets-head">
      <span>Select target trainings that will receive content from Source training.</span>
    </div>

    <div class="ms-filters">
      <select [(ngModel)]="targetKind" (ngModelChange)="searchTargets()">
        <option value="">Kind</option>
        <option value="Education">Education</option>
        <option value="Finance">Finance</option>
        <option value="Law">Law</option>
        <option value="Other">Other</option>
      </select>
      <input type="text" [(ngModel)]="targetSearch" placeholder="Filter by name..." (keyup.enter)="searchTargets()">
      <button (click)="searchTargets()" [disabled]="targetLoading || !targetKind">Search</button>
      <button class="ms-update-btn" [disabled]="!canUpdate" (click)="openUpdateModal()">Replace Section</button>
    </div>

    @if (targets.length > 0) {
      <div class="ms-list-header">
        <label class="ms-check-row">
          <input type="checkbox" [checked]="allSelected" (click)="toggleSelectAll()">
          <span>{{ selectedIds.size }} / {{ targets.length }} selected</span>
        </label>
        @if (selectedSection) {
          <button class="ms-auto-select-btn" [disabled]="autoSelectLoading" (click)="autoSelectSection()">
            {{ autoSelectLoading ? 'Selecting…' : 'Auto select' }}
          </button>
        }
      </div>

      <div class="ms-list">
        @for (target of pagedTargets; track target.hcontent_id) {
          <div class="ms-list-item" [class.active]="previewId === target.hcontent_id"
            (click)="loadTargetPreview(target.hcontent_id)">
            <input type="checkbox" [checked]="selectedIds.has(target.hcontent_id)"
              (click)="$event.stopPropagation(); toggleTarget(target.hcontent_id)">
            <span>{{ target.name?.replaceAll('"', '') }}</span>
          </div>
        }
      </div>

      @if (totalPages > 1) {
        <div class="ms-pagination">
          <button (click)="prevPage()" [disabled]="currentPage === 0">&#8592;</button>
          <span>{{ currentPage + 1 }} / {{ totalPages }}</span>
          <button (click)="nextPage()" [disabled]="currentPage === totalPages - 1">&#8594;</button>
        </div>
      }
    }

    @if (!targetLoading && targetKind && targets.length === 0) {
      <div class="ms-hint">No trainings found.</div>
    }

    @if (targetLoading) {
      <div class="ms-hint">Loading...</div>
    }


  </main>

  <div class="ms-handle" (mousedown)="startResize('right', $event)"></div>

  <!-- Right pane: target preview -->
  <aside class="ms-preview" [style.width.%]="rightWidth">

    <div class="ms-preview-head">
      <span>Review Target Training</span>
      @if (previewId) {
        <span class="ms-preview-link" (click)="openInEditor(previewId)">Open in Editor</span>
      }
    </div>

    @if (previewMetadata) {
      <div class="ms-source-meta">
        <div class="ms-source-name">{{ previewMetadata.name?.replaceAll('"', '') }}</div>
        <div class="ms-source-type">{{ previewMetadata.type }}</div>
      </div>
    }

    @if (previewLoading) {
      <div class="ms-hint">Loading...</div>
    }

    @if (!previewLoading && !previewId) {
      <div class="ms-hint">Select a training to review.</div>
    }

    <div class="ms-tree">
      <app-tree
        [items]="previewItems"
        [level]="0"
        [treeType]="'source'"
        [isEditingEnabled]="false"
        [isReorderEnabled]="false"
        [isDualPane]="false"
        [selectedItemId]="selectedPreviewSectionId"
        [showSelectButton]="true"
        (itemClicked)="onPreviewItemClicked($event)">
      </app-tree>
    </div>

  </aside>

</div>

@if (showUpdateModal) {
  <div class="ms-modal-backdrop" (click)="closeUpdateModal()">
    <div class="ms-modal" (click)="$event.stopPropagation()">

      @if (!updateSubmitted) {
        <div class="ms-modal-title">Replace Section</div>
        <p class="ms-modal-body">
          The first matching <strong>{{ selectedSection }}</strong> section in each of the
          <strong>{{ selectedIds.size }}</strong> selected target training(s) will be replaced
          with the <strong>{{ selectedSection }}</strong> section from
          <strong>{{ sourceMetadata?.name?.replaceAll('"', '') }}</strong>.
        </p>
        <p class="ms-modal-body">This action cannot be undone.</p>
        <div class="ms-modal-actions">
          <button class="ms-modal-cancel" (click)="closeUpdateModal()" [disabled]="updateLoading">Cancel</button>
          <button class="ms-modal-confirm" (click)="confirmUpdate()" [disabled]="updateLoading">
            {{ updateLoading ? 'Updating…' : 'Confirm' }}
          </button>
        </div>
      } @else if (updateSuccess) {
        <div class="ms-modal-title">Done</div>
        <p class="ms-modal-body">
          Content updated successfully across {{ selectedIds.size }} training(s).
        </p>
        <div class="ms-modal-actions">
          <button class="ms-modal-confirm" (click)="closeUpdateModal()">Close</button>
        </div>
      } @else {
        <div class="ms-modal-title">Something went wrong :(</div>
        <p class="ms-modal-body">{{ updateError }}</p>
        <div class="ms-modal-actions">
          <button class="ms-modal-cancel" (click)="closeUpdateModal()">Close</button>
        </div>
      }

    </div>
  </div>
}
